
import { TranslationRecord } from '../../types';

export const suites: TranslationRecord = {
  // Suites Section
  suitesTitle: 'Our Luxury Suites',
  roomFeatures: 'Room Features',
  bathFeatures: 'Bath Features',
  generalAmenities: 'General Amenities',
  viewAllSuites: 'View All Suites',
  suiteGallery: 'Suite Gallery',
  capacity: 'Capacity',
  amenities: 'Amenities',
  services: 'Services',
  
  // What Sets Us Apart section
  whatSetsUsApart: 'What Sets Us Apart',
  spaciousLayout: 'Spacious Layout',
  guests: 'Guests',
  centralLocation: 'Central location in Thessaloniki',
  topRestaurants: 'Top restaurants within walking distance',
  climateControl: 'Climate control (A/C and heating)',
  fullyEquippedKitchen: 'Fully equipped modern kitchen',
  highSpeedWifi: 'High-speed wifi (100 Mbps)',
  personalizedAttention: 'Personalized attention',
  dailyHousekeeping: 'Daily housekeeping service',
  exceptionalStay: 'At Loena Luxury Suites, we ensure your stay is nothing short of exceptional.',
  viewDetails: 'View Details',
  
  // Suite Hero
  luxurySuite: 'Luxury Suite',
  suiteDescription: 'Experience modern comfort in the heart of Thessaloniki. Our 30m² suite combines luxury amenities with thoughtful design.',
  suiteSize: '30m²',
  upToGuests: 'Up to 3 guests',
  queenSingleBed: 'Queen + Single bed',
  
  // Suite Features
  queenBed: '1 Queen bed, 1 Single bed',
  babyCot: 'Baby cot (on request)',
  wifi: 'High-speed Wi-Fi (100 Mbps)',
  fullKitchen: 'Full kitchen',
  diningTable: 'Dining table',
  hdtv: '55" HDTV',
  airConditioning: 'Air Conditioning',
  washerDryer: 'Washer and dryer',
  hotWater: 'Instant hot water 24/7',
  smartLocks: 'Smart electronic locks',
  waterBottles: 'Welcome pack (water, coffee, tea)',
  fireSafetyEquipment: 'Fire safety equipment',
  securityMonitoring: '24/7 monitored security',
  insectScreens: 'Insect screens on all windows',
  dailyCleaning: 'Daily housekeeping',
  luggageStorage: 'Luggage storage',
  transferServices: 'Transfer services',
  restaurantRecommendations: 'Restaurant recommendations',
  earlyCheckIn: 'Early check-in',
  lateCheckout: 'Late check-out (subject to availability)',
  corporateInvoicing: 'Corporate invoicing option',
  ironIroningBoard: 'Iron and ironing board',
  washerDryerExtraCharge: 'Washer / dryer (extra charge)',
  accommodates: "Accommodates",
  upToThreeGuests: "Up to 3 guests",
  
  // Amenities
  premiumAmenities: 'Premium Amenities',
  amenitiesDescription: 'Every detail has been carefully considered to ensure your comfort and convenience during your stay.',
  highSpeedWifiTitle: 'High-Speed WiFi',
  wifiDescription: '100 Mbps complimentary internet',
  smartTv: '55" Smart TV',
  tvDescription: 'Netflix and premium channels included',
  climateControlTitle: 'Climate Control',
  climateDescription: 'Individual air conditioning',
  fullKitchenTitle: 'Full Kitchen',
  kitchenDescription: 'Refrigerator, stove, and cookware',
  laundry: 'Laundry',
  laundryDescription: 'Washer and dryer in-unit',
  smartLocksTitle: 'Smart Locks',
  smartLocksDescription: 'Keyless electronic entry',
  hotWaterTitle: 'Hot Water',
  hotWaterDescription: 'Instant hot water 24/7',
  parking: 'Parking',
  parkingDescription: 'Secure parking available nearby',
  
  // Additional fields
  privateBathroom: 'Private Bathroom',
  livingArea: 'Living Area',
  balcony: 'Balcony',
  heating: 'Heating',
  freeWifi: 'Free Wi-Fi',
  flatScreenTV: 'Flat Screen TV',
  hairDryer: 'Hair Dryer',
  toiletries: 'Toiletries',
  miniBar: 'Mini Bar',
  safeBox: 'Safe Box',
  ironingFacilities: 'Ironing Facilities',
  soundproofing: 'Soundproofing',
  modernDesign: 'Modern Design',
  premiumLocation: 'Premium Location',
  luxuryAmenities: 'Luxury Amenities',
  maxOccupancy: 'Maximum Occupancy',
  bedType: 'Bed Type',
  viewType: 'View Type',
  perfectFor: 'Perfect for',
  couples: 'couples',
  businessTravelers: 'business travelers',
  shortStays: 'short stays',
  bathroomImage: 'Bathroom Image',
  bedroomImage: 'Bedroom Image',
  livingRoomImage: 'Living Room Image',
  kitchenImage: 'Kitchen Image',
  balconyImage: 'Balcony Image',
  
  // Gallery
  suiteGalleryTitle: 'Suite Gallery',
  galleryDescription: 'Take a virtual tour of our luxury accommodation',
  viewImage: 'View Image',
  closeGallery: 'Close gallery',
  previousImage: 'Previous image',
  nextImage: 'Next image'
};
